import { ICubeSchemaMapper } from './cube-schema-mapper.interface';

export interface ICumulativeAverageMapper extends ICubeSchemaMapper {}
